const toTitleCase = (str)=>{
    let x = str[0].toUpperCase();
    let y = str.slice(1).toLowerCase();
    return x+y;
    } 

export default toTitleCase;